// extracted by mini-css-extract-plugin
export default {"modalHeader":"ConfirmModal_modalHeader__R+p8N","modalBody":"ConfirmModal_modalBody__+kVnC","cancelButton":"ConfirmModal_cancelButton__4AnVq"};